<template>
  <div>
    <router-link to="/">  
      <img src="@/assets/home.png" width="32px" height="32px" />
    </router-link>
    <p class="text-impu"> {{  getHeadPage() ? getHeadPage().impuestos[1].texto_impuesto : '' }}  </p>
    <b-input-group class="mt-3">
      <b-form-input v-on:keyup.enter="buscarLiquidacion()" v-model="data"></b-form-input>
      <b-input-group-append>
        <b-button variant="success" @click="buscarLiquidacion()"
          >Buscar</b-button
        >
        <b-button variant="danger" @click="limpiarLiquidacion()"
          >Limpiar</b-button
        >
      </b-input-group-append>
    </b-input-group>
    <b-overlay :show="showLoader" rounded="sm">

    <b-alert v-if="msgAlert" class="alert" show variant="warning">{{
      msgAlert
    }}</b-alert>

    <b-alert v-if="msgSucess" variant="success" show>{{msgSucess}}</b-alert>

    <b-card
      class="card-top"
      :title="'Predio: '.concat(liq ? liq.nombre_predio : '')"
      :sub-title="liq ? liq.numero_predial_nacional : ''"
      v-if="liq"
    >
      <a @click="loadPdf()" class="btn-donwload">
        <img src="@/assets/iconpdf.svg" with="48px" height="48px" />
        <p class="text-link">Descargar</p>
      </a>
      <b-card-text> Dirección: {{ liq ? liq.direccion : "" }} </b-card-text>
      <b-card-text> Zona: {{ liq ? liq.zona : "" }} </b-card-text>
      <span> Liquidaciones: </span>
      <table style="width:100%">
        <tr>
          <th>#</th>
          <th>Liquidacion</th>
          <th>Vigencia</th>
          <th>Fecha vencimiento</th>
          <th>Valor</th>
        </tr>
        <tr v-for="(item, index) in liq ? liq.liquidaciones : []">
          <td>{{ index + 1 }}</td>
          <td>{{ item.codigo_liquidacion }}</td>
          <td>{{ item.ano_mes }}</td>
          <td>{{ item.fecha_vencimiento }}</td>
          <td>{{ item.valor_liquidacion | money}}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td><b> TOTAL: </b></td>
          <td>
            <b> {{ liq ? liq.deuda : "" | money }} </b>
          </td>
        </tr>
      </table>
      <b-card-text> <b> NOTA: </b> {{ liq ? liq.nota : "" }} </b-card-text>
      <span> Propietarios: </span>
      <b-list-group>
        <b-list-group-item v-for="item in liq ? liq.propietarios : []">
          {{ item.nombre }}
        </b-list-group-item>
      </b-list-group>
      <b-button v-if="!showPagador" variant="primary" class="btn-pse" @click="openPagador()">
        Pagar PSE
      </b-button>
    </b-card>

<b-card v-if="showPagador">
    <div >
    <Pagador 
      @to-pse-event="goPSE"
      @cancel-pse-event="cancelPagador"
    >      
    </Pagador>
      
    </div>
    </b-card>
    </b-overlay>

    <b-modal scrollable v-model="pdfShow" size="xl" :title="pdfSelect">
      <template v-slot:modal-header="{ close }">
        <h5>{{ pdfSelect }}</h5>
        <a :download="pdfSelect.concat('.pdf')" :href="pdfDoc">
          <b-icon icon="box-arrow-down"></b-icon>
          Descargar
        </a>
      </template>

      <pdf :src="pdfDoc"></pdf>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="danger" @click="closePdf()">
          Salir
        </b-button>
      </template>
    </b-modal>


    <b-modal  v-model="showConfirm" hide-footer title="Confirmación">
      <div class="d-block text-center">
        <h4> ¿ Está seguro de los datos ingresados ? </h4>
      </div>
      <div>
        <b-button class="mt-2" variant="danger"  @click="cancelConfirmPSE">Cancelar</b-button>
        <b-button class="mt-2" variant="primary" style="float: right;"  @click="confirmPSE"> Aceptar </b-button>
      </div>      
    </b-modal>

  </div>
</template>

<script>
import pdf from "vue-pdf";
import Pagador from "@/components/Pagador.vue";
import {  mapActions, mapGetters } from "vuex";

export default {
  name: "LiquidacionPredial",
  components: {
    pdf,
    Pagador
  },
  data: function() {
    return {
      data: "18-753-",
      liq: null,
      pdfDoc: "",
      pdfShow: false,
      pdfSelect: "Liquidacion",
      msgAlert: null,
      msgSucess: null,
      showLoader: false,
      showPagador: false,
      showConfirm: false,
      pagador: {} 
    };
  },
  methods: {
    ...mapActions("predial", {
      loadLiquidacionsNPN: "loadLiquidacionsNPN",
      loadPdfLiquidacion: "loadPdfLiquidacion",
    }),
    ...mapActions("pse", {
      loadToPSE: "loadToPSE",
      loadValidatePSE: "loadValidatePSE",
    }),
    ...mapGetters("pse", {
      getHeadPage: "getHeadPage",
    }),
    async buscarLiquidacion() {
      try {
        this.limpiarLiquidacion();
        if(this.showLoader) return;
        this.showLoader = true;
        let dataLiq = await this.loadLiquidacionsNPN(this.data);
        if (
          !dataLiq ||
          dataLiq.status != 200 ||
          dataLiq.data.status == "error"
        ) {
          throw "Sin respuesta";
        }

        if (dataLiq.data.data.length > 0) {
          if(this.liq = dataLiq.data.data[0].row_to_json) this.liq = dataLiq.data.data[0].row_to_json;
          else this.liq = dataLiq.data.data[0];
        } else {
          this.msgAlert = "No se encontro liquidacion.";
        }
      } catch (er) {
        this.msgAlert =
          "No se pudo obtener datos, por favor intente en otro momento.";
      }
      
      this.showLoader = false;
    },
    limpiarLiquidacion() {
      if(this.showLoader) return;
      this.liq = null;
      this.msgAlert = null;
      this.showPagador = false;
      this.msgSucess = null;
    },
    async loadPdf() {
      try {
        this.showLoader = true;
        if (this.liq && this.liq.liquidaciones.length <= 0) {          
          throw "Sin Liquidaciones Validas.";
        }

        let nameLiq = this.liq.liquidaciones[0].codigo_liquidacion;
        let dataPdf = await this.loadPdfLiquidacion(nameLiq);
        if (
          !dataPdf ||
          dataPdf.status != 200 ||
          dataPdf.data.status == "error"
        ) {
          throw "Sin respuesta";
        }

        if (dataPdf.data.data.data) {
          this.pdfDoc = "data:application/pdf;base64,".concat(
            dataPdf.data.data.data
          );

          this.pdfSelect = "Liquidacion - ".concat(nameLiq);
          this.pdfShow = true;
        } else {
          this.msgAlert =
            "No se pudo obtener la liquidacion, por favor intente en otro momento.";
        }
      } catch (er) {
        this.msgAlert =
          "No se pudo obtener la liquidacion, por favor intente en otro momento.";
      }
      this.showLoader = false;
    },
    closePdf() {
      this.pdfShow = false;
    },
    openPagador(){
      this.showPagador = true;
    },
    cancelPagador(){
      this.showPagador = false;
    },
    goPSE(data){
      this.pagador = {
        Identificacion: data[1],
		    TipoDocumento: data[0],
		    Nombre: data[2],
		    Telefono: data[4],
        Email: data[3]
      }
      this.showConfirm = true;
    },
    async confirmPSE() {
      this.showConfirm = false;
      this.showLoader = true;
      let responsePSE = await this.loadToPSE({
        ref: this.liq.numero_predial_nacional,
        liq: this.liq.liquidaciones[0].codigo_liquidacion,
        valor: String(this.liq.deuda),
        tipoImp: "1",
        Pagador: this.pagador
      });

      let status = responsePSE.data.status;
      if (responsePSE.status == 200 && status == "succes") {

        let idTransaccion = responsePSE.data.data.IdTransaccion;        
        if (responsePSE.data.data.estado) {
        
          localStorage.setItem("ref", this.liq.numero_predial_nacional);
          localStorage.setItem("liq", this.liq.liquidaciones[0].codigo_liquidacion);
          localStorage.setItem("id_transaccion", idTransaccion);
          localStorage.setItem("tipo","1");
          this.showLoader = false;
          this.openpse = true;

          this.$router.push('/validate');
          return;
        }

        let urlData = responsePSE.data.data.URL;
        var linkPSE = document.createElement("a");
        linkPSE.href = urlData;
        linkPSE.target = "_blank";
        linkPSE.click();
        
        localStorage.setItem("ref", this.liq.numero_predial_nacional);
        localStorage.setItem("liq", this.liq.liquidaciones[0].codigo_liquidacion);
        localStorage.setItem("id_transaccion", idTransaccion);
        localStorage.setItem("tipo","1");

        this.showLoader = false;
        this.openpse = true;
      } else {
        this.showLoader = false;
        this.limpiarLiquidacion();
        this.msgAlert = "No se puede iniciar el proceso de pago, intentelo mas tarde.";
      }
    },
    cancelConfirmPSE() {
      this.showConfirm = false;
      this.msgAlert = null;
    },
    async validatePagoPSE(){
      let responsePSE = await this.loadValidatePSE({
        ref: this.liq.numero_predial_nacional,
        liq: this.liq.liquidaciones[0].codigo_liquidacion,
        tipoImp: "1"
      });

      this.showLoader = false;
      this.limpiarLiquidacion();

      if(responsePSE.status == 200 && status == "succes"){
        this.msgSucess = "El pago se ha registrado de manera exitosa.";
      }else if(responsePSE.status == 200 && status == "error"){
        this.msgAlert = "El pago esta sujeto a validacion dentro de las 24 Horas.";
      }else{
        this.msgAlert = "El proceso de pago esta sujeto a validacion. ";
      }      
    }
  },
  filters: {
    money: function (value) {
      let val = (value/1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style>
.alert {
  margin-top: 1rem;
}

.card-top {
  margin-top: 2rem;
}

.btn-donwload {
  float: right;
  display: block;
  text-align: center;
}

img {
  margin: 0px;
}

.text-link {
  margin: 0px;
}

a {
  cursor: pointer;
}

th, td {
  text-align: left;
  padding: 0.5rem;
}

tr:nth-child(even) {background-color: #f2f2f2;}

.btn-pse{
  float: right;
  margin-top: 1rem;
}

.text-impu{
  margin-top: 1rem;
}
</style>
